var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container praticas-sustentaveis" },
    [
      _c(
        "div",
        { staticClass: "content-cadastro" },
        [
          _c("TitlePage", {
            attrs: {
              title: "Bem-vindo(a) ao Plano ABC+ PA",
              subTitle: "Cadastre práticas sustentáveis aqui!"
            }
          }),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 20 } },
                [
                  _c("FiltroGenerico", {
                    attrs: {
                      placeholder:
                        "Pesquisar por número do protocolo ou nome do proprietário..."
                    },
                    on: {
                      filtrosPesquisa: _vm.pesquisar,
                      limpar: _vm.limparPesquisa
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "filtros",
                        fn: function() {
                          return [
                            _c("InputSelect", {
                              attrs: {
                                label: "Municípios:",
                                multiSelect: true,
                                opcoes: _vm.municipios
                              },
                              model: {
                                value: _vm.filtro.municipios,
                                callback: function($$v) {
                                  _vm.$set(_vm.filtro, "municipios", $$v)
                                },
                                expression: "filtro.municipios"
                              }
                            })
                          ]
                        },
                        proxy: true
                      }
                    ])
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-end"
                  },
                  attrs: { span: 4 }
                },
                [
                  _c("CustomButton", {
                    attrs: { icon: "el-icon-plus", text: "Novo cadastro" },
                    on: { click: _vm.novoCadastro }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("BaseTable", {
            attrs: {
              title: "Listagem",
              tableData: _vm.cadastros,
              emptyText: "Não foram encontrados cadastros.",
              columns: [
                { key: "protocolo", label: "N° Cadastro" },
                { key: "proprietarioNomeRazaoSocial", label: "Proprietário" },
                { key: "tipoCadastro", label: "Tipo de cadastro" },
                { key: "municipio", label: "Município" },
                { key: "data", label: "Última atualização" },
                { key: "actions", label: "Ações" }
              ],
              pagination: {
                show: true,
                pageSize: _vm.filtro.tamanhoPagina,
                totalPages: _vm.totalPages,
                totalElements: _vm.totalElements
              }
            },
            on: { pageChange: _vm.changePage }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("RegistrationTypeModal", {
        attrs: {
          visible: _vm.modalVisible,
          closeOnClickOutside: true,
          title: "Selecione qual o tipo de cadastro:",
          options: [
            {
              key: "EMPRESA",
              label: "Empresa"
            },
            {
              key: "PARCEIROS_FORNECEDORES",
              label: "Parceiros/Fornecedores"
            }
          ]
        },
        on: {
          "update:visible": function($event) {
            _vm.modalVisible = $event
          },
          onRegistrationSelected: _vm.handleRegistrationSelected,
          closeModal: _vm.closeModal
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-15edb61f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15edb61f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App/(authenticated)/modulos/cadastro/listagem-cadastros/listagem-cadastros.vue
// module id = null
// module chunks = 